import { Link } from 'react-router-dom';
import { SorterResult } from 'antd/lib/table/interface';

import { Links } from 'links';

import { ProductDashboardDto } from 'codegen';
import { TColumn } from 'types';

export const columns = (sortOrderInfo?: SorterResult<ProductDashboardDto>): TColumn<ProductDashboardDto>[] => [{
  width: 70,
  title: 'ID',
  dataIndex: 'order',
  sorter: true,
  sortOrderInfo,
  render: (order, { id }) => (
    <Link
      to={`${Links.Products}/${id}`}
      state={{ redirectFrom: `${Links.Offers}${window.location.search}` }}
    >
      {order}
    </Link>
  ),
}, {
  type: TColumn.type.Ellipsis,
  width: 300,
  title: 'Name',
  dataIndex: 'name',
}, {
  width: 100,
  title: 'Product ID',
  dataIndex: 'productId',
}, {
  type: TColumn.type.FetchImageByID,
  width: 80,
  title: 'Image',
  dataIndex: 'imageMetadataId',
}, {
  width: 120,
  title: 'Sponsor Code',
  dataIndex: 'sponsorCode',
}, {
  type: TColumn.type.Status,
  width: 100,
  title: 'Status',
  dataIndex: 'status',
  sorter: true,
  sortOrderInfo,
}, {
  type: TColumn.type.Date,
  width: 180,
  title: 'Effective From',
  dataIndex: 'effectiveFrom',
  dateFormat: 'YYYY/MM/DD',
  sorter: true,
  sortOrderInfo,
}, {
  type: TColumn.type.Date,
  width: 180,
  title: 'Effective To',
  dataIndex: 'effectiveTo',
  dateFormat: 'YYYY/MM/DD',
  sorter: true,
  sortOrderInfo,
}];
